
























































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import { getRegions } from '../models/api'
const directCities = ['北京', '天津', '重庆', '上海']

@Component({
  components: { SingleRowSelect }
})
export default class Condition extends Vue {
  @Prop() public msg!: string

  public filterList = []
  public grade = ''
  // public rating = ''
  public grade_name = ''
  public section = 0
  public section_name = '全部'
  public year = ''
  public paper_type = ''
  public paper_type_name
  public city = 0 // 市
  public city_name = '' // 市
  public cityArray: any[] = [] // 市

  public district = 0 // 区
  public district_name = '' // 区
  public districtArray: any[] = [] // 区
  public get showName() {
    console.log(this.section_name)
    return directCities.indexOf(this.section_name) > -1 ? '区：' : '市：'
  }
  public get allRules() {
    return this.$store.state.allRules
  }

  public get getFilters() {
    return this.$store.state.filters
  }
  // 添加默认筛选项
  public get defaultProvince() {
    if (
      this.$store.state.user_info &&
      this.$store.state.user_info.regions &&
      this.$store.state.user_info.regions.length > 0 &&
      !this.$route.query.sort_way
    ) {
      return {
        val: this.$store.state.user_info.regions[0].code,
        name: this.$store.state.user_info.regions[0].name
      }
    } else {
      return { name: '全部', val: 0 }
    }
  }

  public get defaultType() {
    let type = this.$route.query.sort_way
    let source = this.$store.state.allRules && this.$store.state.allRules[3] // 试卷类型
    let result = source.val.find((item) => item.val == type)
    return result || { name: '全部', val: 0 }
  }
  @Watch('getFilters', { deep: true })
  onFiltersChange(val) {
    // console.log('val99', val)
    this.city = val.city
    if (this.defaultProvince.val !== this.section) {
      this.cityArray = val.cityArray
    }
    this.districtArray = val.districtArray
    this.district = val.district
    this.grade = val.grade
    this.year = val.year
    this.paper_type = val.paper_type
  }

  @Watch('allRules', { immediate: true, deep: true })
  onRulesChange(val: any) {
    this.filterList = val
  }
  @Watch('section')
  onSectionChange(val: any) {
    console.log(val)
    if (val != 0) {
      this.getRegions(val, 'city')
    } else {
      this.section = 0
      this.section_name = '全部'
      this.cityArray = []
    }
    this.city = 0
    this.city_name = ''
    this.cityArray = []
    this.district = 0
    this.district_name = ''
    this.districtArray = []
    this.dispatchData()
  }

  public clickCity(itm) {
    this.city = itm.code
    this.city_name = itm.name
    this.district = 0
    this.district_name = ''
    this.districtArray = []
    this.getRegions(itm.code, 'district')
    this.dispatchData()

    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'city',
      button_1_name: '市',
      button_2: this.city,
      button_2_name: this.city_name || ''
    })
  }

  public clickDistrict(itm) {
    this.district = itm.code
    this.district_name = itm.name
    this.dispatchData()

    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'district',
      button_1_name: '区',
      button_2: this.district,
      button_2_name: this.district_name || ''
    })
  }
  public judgeSelected(itm, type) {
    if (type === 'city') {
      return itm.code === this.city
    } else {
      return itm.code === this.district
    }
  }
  public async getRegions(val, type) {
    if (val !== 0) {
      let obj = {
        pcode: val
      }
      try {
        const { data } = await getRegions(obj)
        if (type === 'city') {
          this.cityArray = [{ code: 0, name: '全部' }, ...data]
        } else {
          if (data && data.length) {
            this.districtArray = [{ code: 0, name: '全部' }, ...data]
          } else {
            this.districtArray = []
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  // methods
  public getChoose(val: any) {
    switch (val.group) {
      case '年级：':
        this.grade = val.value
        this.grade_name = val.name
        // this.rating = val.rating || ''
        this.dispatchData()
        break
      case '地区：':
        this.section = val.value
        this.section_name = val.name
        this.dispatchData()
        break
      case '年份：':
        this.year = val.value
        this.dispatchData()
        break
      case '类型：':
        this.paper_type = val.value
        this.paper_type_name = val.name
        this.dispatchData()
        break
      default:
        break
    }
  }
  /**
   * dispatchData
   */
  public dispatchData() {
    var region_code1
    var region_name1
    if (this.district) {
      region_code1 = this.district
      region_name1 = this.district_name
    } else if (this.city) {
      region_code1 = this.city
      region_name1 = this.city_name
    } else if (this.section || this.section === 0) {
      region_code1 = this.section
      region_name1 = this.section_name
    }

    this.$store.commit('SET_FILTERS', {
      grade: this.grade,
      // rating: this.rating,
      grade_name: this.grade_name,
      region_code: region_code1,
      region_name: region_name1,
      year: this.year,
      paper_type: this.paper_type,
      paper_type_name: this.paper_type_name,
      city: this.city,
      district: this.district,
      cityArray: this.cityArray,
      districtArray: this.districtArray
    })
  }
}
